const messages = {
  en: {
    beginReservation: 'Start of reservation',
    lengthOfTime: 'Duration',
    weeks: 'Week | Weeks',
    More: 'More',
    contactUsDirectlyForLargerMoves: 'For larger relocations with offices or a library etc., please {0} us directly.',
    Contact: 'contact',
    contact: 'contact',
    next: 'Continue',

    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',

    '2 weeks': '2 weeks',
    '3 weeks': '3 weeks',
    '4 weeks': '4 weeks',
    '5 weeks': '5 weeks',
    '6 weeks': '6 weeks',
    '7 weeks': '7 weeks',
    '8 weeks': '8 weeks',

    pleaseSelectYourItems: 'Please select your items',
    notSureCalculateYourNeeds: 'Not sure? {0}',
    calculateNeeds: 'Calculate your required quantity here',
    youShouldRentXXBoxes: 'You should rent <span>{amount}</span> boxes.',

    deliverBoxToHome: 'Have boxes delivered',
    pickUpBoxesYourself: 'Pick up the boxes',
    shippingAddress: 'Delivery address',
    beforeMove: 'before move',
    pickupAddress: 'Collection address',
    afterMove: 'after relocation',
    Address: 'Street',
    zipCode: 'ZIP',
    City: 'City',
    'Additional Information': 'Further information',
    sameDeliveryAddressBeforeAndAfterMoving: 'Delivery address corresponds to collection address after relocation',
    pleaseEnterYourAddress: 'Please enter your address:',
    pleaseEnterYourZipCode: 'Please enter your zip code:',

    yourPersonalData: 'Your personal details',
    Salutation: 'Title',
    'First Name': 'First name',
    'Last Name': 'Last name',
    Company: 'Company',
    'Email address': 'E-Mail Adresse',
    Mobile: 'Mobile phone',
    Notes: 'Notes',
    getYourDataFromSwisspass: 'Get your data from SwissPass',
    swisspassID: 'Swiss Pass ID',
    'Load data': 'Load data',
    'Do you have voucher?': 'Do you have a voucher?',
    'Voucher Code': 'Voucher Code',
    'Apply Voucher': 'Apply Voucher',
    'I accept the': 'I accept the general {0}',
    'Terms and Conditions': 'terms and conditions',

    Summary: 'Summary',
    'Reserve and go to payment': 'Checkout',

    // Country Selector
    Switzerland: 'Switzerland',
    Germany: 'Germany',
    Austria: 'Austria',
    Liechtenstein: 'Liechtenstein',

    // STEP 4
    swissPassError: 'Seems that something goes wrong. Please try later.',
    Country: 'Country',
    HERR: 'Mr',
    FRAU: 'Mrs',
    '---': '---',
    fillInIfBusinessOrder: 'Please complete if this is a business order.',
    choose: 'select', // Button on map to select store
    'Remove data': 'Remove data',

    // STEP 5
    'Contact Information': 'Contact details',
    'Delivery details': 'Delivery address',
    'Your Products': 'Your Products',
    billingAddress: 'Billing address',
    'Pickup place details': 'Pick up location details',
    Date: 'Date',

    // bottom bar
    from: 'from', // Price from
    for: 'for',
    article: '{amount} item | {amount} items',

    // MAP
    'User Location': 'Your location',

    // User needs calculator
    calculator: {
      numberOfRooms: 'Number of rooms',
      numberOfAdults: 'Number of adults',
      numberOfYears: 'Number of years living at this place',
    },

    // Payment
    'Payment Form': 'Payment form',

    // Thank you page
    'Thank You!': 'Danke!',
    'Your reservation was successful.': 'Your reservation was successful.',
    'Please check your email with the reservation details.': 'Please check your email with the reservation details.',
    'Your reservation number is #{number}': 'Your reservation number is R#{number}',
    'After changing any of this value your basket will be cleared.':
      'After changing any of this value your basket will be cleared.',
    'Please confirm your location:': 'Please confirm your location:',
  },
}

export default messages
